import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
// import { CircleIcon, SquareIcon, VercelLogoIcon } from '@radix-ui/react-icons';
import { CircleIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  breakpoints,
  DMRadioItem,
  preventEvent,
  SizeStyle,
  StyledGroup,
  TDSnapshot,
  useTldrawApp,
} from 'sn-wb-tldraw';
import { Utils } from 'sn-wb-tldraw-core';

export const strokeSize = {
  small: (
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="3" cy="3" r="3" fill="#D5D7DD" />
    </svg>
  ),
  medium: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="6" fill="#D5D7DD" />
    </svg>
  ),
  large: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7" cy="7" r="7" fill="#D5D7DD" />
    </svg>
  ),
};

const statusSelector = (s: TDSnapshot) => s.appState.status;

const currentStyleSelector = (s: TDSnapshot) => s.appState.currentStyle;

export const SizeSelector = React.memo(function SizeSelector() {
  const app = useTldrawApp();

  const currentStyle = app.useStore(currentStyleSelector);
  const [displayedStyle, setDisplayedStyle] = React.useState(currentStyle);

  const handleSizeChange = React.useCallback((value: string) => {
    app.style({ size: value as SizeStyle });
  }, []);

  return (
    <>
      <StyledGroup dir="ltr" value={displayedStyle.size}>
        <div className="flex flex-row gap-3  justify-center items-center">
          {Object.keys(strokeSize).map((sizeStyle) => (
            <div key={sizeStyle} className="w-29">
              <DropdownMenu.Item asChild>
                <div
                  onClick={handleSizeChange.bind(null, sizeStyle)}
                  className="w-20 h-20 flex justify-center rounded-sm items-center cursor-pointer hover:bg-gray-100"
                >
                  {strokeSize[sizeStyle]}
                </div>
              </DropdownMenu.Item>
            </div>
          ))}
        </div>
      </StyledGroup>
    </>
  );
});
